<template>
  <a
    v-if="data.href"
    :href="data.href"
    target="_blank"
    class="van-button van-button--default van-button--normal"
    >{{ data.title }}
  </a>
  <a
    v-else-if="data.tel"
    :href="'tel:' + data.tel"
    class="van-button van-button--default van-button--normal"
    >{{ data.title }}</a
  >
  <van-button v-else type="default" @click="goPath()">{{
    data.title
  }}</van-button>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "BaseLink",
  props: { data: Object },
  methods: {
    ...mapActions(["SetLeave"]),
    /**
     * @description 前往对应页面
     */
    goPath() {
      this.$emit("handlerToken");
      this.$emit("handlerShow");
      this.SetLeave(true);
      this.$router.replace({
        path: this.data.path
      });
    }
  }
};
</script>
